// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import {SessionStart} from 'public/Hevrati.js';
import {NewLead} from 'public/Hevrati.js';

$w.onReady(function () {

    SessionStart();

    $w("#dataset1").onAfterSave( () => {
        NewLead($w("#input1").value, $w("#input2").value, '/talk');
    } );

});